import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { SmoothScroll } from "@/components/SmoothScroll";
import { PrismLoader } from "@/components/PrismLoader";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Jobs from "@/pages/Jobs";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <PrismLoader />
      <SmoothScroll>
        <div className="relative min-h-screen bg-axor-hero font-sans text-axor-white">
          <div className="grain-overlay" />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
